import { Typography } from '@mui/material';

import { MerchantWrapperStyles } from './MerchantWrapper.style';

type MerchantWrapperProps = {
  merchant: string;
  price?: string;
  date: string;
};

export const MerchantWrapper = ({ merchant, price, date }: MerchantWrapperProps): JSX.Element => {
  return (
    <>
      {price && (
        <MerchantWrapperStyles.Price color='common.white' variant='subtitle1'>
          {price}
        </MerchantWrapperStyles.Price>
      )}
      <MerchantWrapperStyles.Merchant color='common.white' variant='subtitle3' sx={{ typography: { lg: 'subtitle1' } }}>
        {merchant}
      </MerchantWrapperStyles.Merchant>
      <Typography color='common.white' variant='caption' sx={{ typography: { lg: 'subtitle1' } }}>
        {date}
      </Typography>
    </>
  );
};
